import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="unauthorized-container">
      <div class="alert-box">
        <h2>🚫 Access Denied</h2>
        <p>You are not authorized to view this page.</p>
        <button (click)="goBack()" class="btn primary">Go Back</button>
      </div>
    </div>
  `,
  styles: [`
    .unauthorized-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 2rem;
    }
    .alert-box {
      background: white;
      padding: 2rem;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      text-align: center;
      border: 1px solid #e2e8f0;
      max-width: 400px;
    }
    h2 { color: #ef4444; margin-top: 0; }
    p { color: #64748b; margin-bottom: 1.5rem; }
    .btn {
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-weight: 500;
      background-color: #2563eb;
      color: white;
    }
    .btn:hover { background-color: #1d4ed8; }
  `]
})
export class UnauthorizedComponent {
  constructor(private location: Location) {}
  
  goBack() {
    this.location.back();
  }
}